<template>
  <div class="cart wishlist">
    <a :href="clickThrough" class="icon-cart-link">
      <i class="icon icon-star"></i>
      <div class="count">
        <div class="value">{{ count }}</div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "wishlist-header",
  props: ["netsuite_url", "enable_b2c", "enable_b2b"],
  data() {
    return {
      cartmode: false,
      cartcount: 0
    };
  },
  mounted() {
    let vm = this;
    var enables = new Object();
    enables["enable_b2b"] = this.enable_b2b;
    enables["enable_b2c"] = this.enable_b2c;

    vm.$store.commit("wishlist/setCartCount", 0);
  },
  methods: {},
  computed: {
    clickThrough() {
      return "wishlist";
    },
    count() {
      return this.$store.getters["wishlist/count"];
    }
  }
};
</script>
